/** The name a downloaded file artifact is saved under.
 *
 *  An artifact's title is a label ("Invoice review — 1601271241"), not a
 *  filename: it has no extension, so a browser may save it as an untyped file.
 *  Add the extension its mime implies, and replace the characters a filename
 *  cannot hold. A title that already ends in an extension is left alone. */

const EXTENSION_BY_MIME: Record<string, string> = {
  "text/plain": ".txt",
  "text/csv": ".csv",
  "application/json": ".json",
};

const HAS_EXTENSION = /\.[A-Za-z][A-Za-z0-9]{0,7}$/;

function baseMime(mime: string | null | undefined): string {
  return (mime ?? "").toLowerCase().split(";")[0].trim();
}

/** A markdown mime (text/markdown, text/x-markdown), with or without params. */
export function isMarkdownMime(mime: string | null | undefined): boolean {
  return baseMime(mime).includes("markdown");
}

function extensionFor(mime: string | null | undefined): string {
  if (isMarkdownMime(mime)) return ".md";
  return EXTENSION_BY_MIME[baseMime(mime)] ?? "";
}

export function downloadName(
  title: string | null | undefined,
  mime: string | null | undefined,
): string {
  const base = (title ?? "").replace(/[<>:"/\\|?*]/g, "_").trim() || "artifact";
  return HAS_EXTENSION.test(base) ? base : base + extensionFor(mime);
}
